module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "toc"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmh1"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_tp_r1"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_cop_r1"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_ata_r1"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_fm1_r1"
    }
  }, [_vm._v("CREDITS")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_frw_r1"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('div', {
    staticClass: "cfmh"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_itr_r1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_itr_r1#h1"
    }
  }, [_vm._v("Why Another Book on Software Project Management?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_itr_r1#h2"
    }
  }, [_vm._v("What Is This Book About?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_itr_r1#h3"
    }
  }, [_vm._v("What Is the Purpose of This Book?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_itr_r1#h4"
    }
  }, [_vm._v("Who Should Read This Book?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_itr_r1#h5"
    }
  }, [_vm._v("How Will You Benefit from Reading This Book?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_itr_r1#h6"
    }
  }, [_vm._v("How Is This Book Organized?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_itr_r1#h7"
    }
  }, [_vm._v("What Are the Features of the Book?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_itr_r1#h8"
    }
  }, [_vm._v("What’s on the Web Site?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_itr_r1#h9"
    }
  }, [_vm._v("How Should You Read This Book?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_itr_r1#h10"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_p01_r1"
    }
  }, [_vm._v("PART ONE - The Evolving State of ESPM")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c01_r1"
    }
  }, [_vm._v("CHAPTER 1 - The Changing Landscape of Software Development")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c01_r1#h1"
    }
  }, [_vm._v("What Is a Software Development Project?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c01_r1#h2"
    }
  }, [_vm._v("What Is Software Development Project Management?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c01_r1#h3"
    }
  }, [_vm._v("The Complexity/Uncertainty Domain of SDPM")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c01_r1#h4"
    }
  }, [_vm._v("Balancing Staff, Process, Technology")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('a', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c01_r1#h5"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 2 - SDPM Roadmap")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c02_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Contemporary Software Development Landscape")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c02_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Generic Template for Discussing SDPM Strategies")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c02_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_p02_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO - Linear ESPM")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3 - Linear SDPM Strategy")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c03_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Linear SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c03_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Types of Linear SDPM Strategies")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c03_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4 - The Linear SDPM Scoping Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c04_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solution Definition")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c04_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Requirements Gathering")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c04_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Customer Sign-Off on Requirements")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c04_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project Overview Statement")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c04_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5 - The Linear SDPM Planning Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c05_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Work Breakdown Structure Template")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c05_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dependency Diagramming")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c05_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project Scheduling")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c05_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resource Requirements")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c05_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6 - The Linear SDPM Launching Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c06_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Team Leadership Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c06_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Organizing the Linear SDPM Strategy Project Team")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c06_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Managing Concurrent Swim Lanes")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c06_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7 - The Linear SDPM Monitoring and Controlling Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c07_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project Review Sessions")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c07_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scope Change Management")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c07_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milestone Trend Charts")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c07_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c08_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 8 - The Linear SDPM Closing Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c08_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Requirements Validation")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c08_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acceptance Test Procedures")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c08_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Customer Sign-Off")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c08_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Closing Phase")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c08_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lessons Learned")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c08_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c09_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9 - The Linear SDPM Strategy Summary")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c09_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comparing and Contrasting the SDPM Models")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c09_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Points to Remember")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c09_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_p03_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART THREE - Incremental ESPM")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10 - Incremental SDPM Strategy")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c10_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Incremental SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c10_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Types of Incremental SDPM Strategies")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c10_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11 - The Incremental SDPM Scoping Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c11_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scoping Phase of an Incremental SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c11_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scoping Phase of the Incremental SDPM Strategy  for the Staged Delivery  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c11_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scoping Phase of the Incremental SDPM Strategy for the Feature-Driven  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c11_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Role of the RBS")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c11_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Role of the Precedence Diagram")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c11_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c12_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12 - The Incremental SDPM Planning Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c12_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planning Phase of an Incremental SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c12_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planning Phase of an Incremental SDPM Strategy for the Staged Delivery  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c12_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planning Phase of an Incremental SDPM Strategy for the Feature-Driven  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c12_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c13_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13 - The Incremental SDPM Launching Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c13_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching Phase of an Incremental SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c13_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching Phase of an Incremental SDPM Strategy for the Staged Waterfall Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c13_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching Phase of an Incremental SDPM Strategy for the Feature-Driven  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c13_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c14_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14 - The Incremental SDPM Monitoring and Controlling Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c14_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Monitoring and Controlling Phase of an Incremental SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c14_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Project Review Sessions")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c14_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scope Change Management")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c14_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c15_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15 - The Incremental SDPM Closing Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c15_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Closing Phase of the Incremental SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c15_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Incremental SDPM Strategy for the Closing Phase of the Staged Delivery  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c15_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Incremental SDPM Strategy for the Closing Phase of the Feature-Driven  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c15_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c16_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16 - The Incremental SDPM Strategy Summary")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c16_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comparing and Contrasting the SDPM Models")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c16_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Points to Remember")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c16_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_p04_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART FOUR - Iterative ESPM")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c17_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17 - Iterative SDPM Strategy")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c17_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Iterative SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c17_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Types of Iterative SDPM Strategies")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c17_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c18_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18 - The Iterative SDPM Scoping Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c18_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scoping Phase of an Iterative SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c18_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scoping Phase of the Iterative SDPM Strategy  for the Evolutionary  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c18_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scoping Phase of the Iterative SDPM Strategy for the SCRUM Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c18_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scoping Phase of the Iterative SDPM Strategy for the Rational Unified  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c18_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scoping Phase of the Iterative SDPM Strategy for the Dynamic Systems  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c18_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c19_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19 - The Iterative SDPM Planning Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c19_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planning Phase of an Iterative SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c19_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planning Phase of an Iterative SDPM Strategy for the Evolutionary  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c19_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planning Phase of an Iterative SDPM Strategy for the SCRUM Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c19_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planning Phase of an Iterative SDPM Strategy for the Rational Unified  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c19_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planning Phase of an Iterative SDPM Strategy for the Dynamic Systems  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c19_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c20_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20 - The Iterative SDPM Launching Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c20_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching Phase of an Iterative SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c20_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching Phase of an Iterative SDPM Strategy for the Evolutionary  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c20_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching Phase of an Iterative SDPM Strategy for the SCRUM Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c20_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching Phase of an Iterative SDPM Strategy for the Rational Unified  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c20_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching Phase of an Iterative SDPM Strategy  for the Dynamic Systems  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c20_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c21_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21 - The Iterative SDPM Monitoring and Controlling Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c21_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Monitoring and Controlling Phase of an Iterative SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c21_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Monitoring and Controlling Phase of an Iterative SDPM Strategy for the  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c21_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Monitoring and Controlling Phase of an Iterative SDPM Strategy for the  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c21_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Monitoring and Controlling Phase of an Iterative SDPM Strategy for the  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c21_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Monitoring and Controlling Phase of an Iterative SDPM Strategy for the  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c21_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c22_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22 - The Iterative SDPM Closing Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c22_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Closing Phase of the Iterative SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c22_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iterative SDPM Strategy for the Closing Phase of the Evolutionary Development  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c22_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iterative SDPM Strategy for the Closing Phase of the SCRUM Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c22_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iterative SDPM Strategy for the Closing Phase of the Rational Unified Process Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c22_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iterative SDPM Strategy for the Closing Phase of the Dynamic Systems  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c22_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c23_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23 - The Iterative SDPM Strategy Summary")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c23_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Agile Projects")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c23_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Agile Project Managers")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c23_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Agile Teams")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c23_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Agile Project Planning")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c23_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Agile Scope Change Management")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c23_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Question")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_p05_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART FIVE - Adaptive ESPM")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c24_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24 - Adaptive SDPM Strategy")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c24_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Adaptive SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c24_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Types of Adaptive SDPM Strategies")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c24_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c25_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25 - The Adaptive SDPM Scoping Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c25_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scope Phase of an Adaptive SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c25_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scoping Phase of the Adaptive SDPM Strategy for the Adaptive Project  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c25_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scoping Phase of the Adaptive SDPM Strategy for the Adaptive Software  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c25_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c26_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 26 - The Adaptive SDPM Planning Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c26_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planning Phase of an Adaptive SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c26_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planning Phase of an Adaptive SDPM Strategy for the Adaptive Project  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c26_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planning Phase of an Adaptive SDPM Strategy for the Adaptive Software  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c26_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c27_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 27 - The Adaptive SDPM Launching Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c27_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching Phase of an Adaptive SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c27_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching Phase of an Iterative SDPM Strategy for the Adaptive Project  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c27_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching Phase of an Adaptive SDPM Strategy for the Adaptive Software  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c27_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Question")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c28_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 28 - The Adaptive SDPM Monitoring and Controlling Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c28_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Monitoring and Controlling Phase of an Adaptive SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c28_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Monitoring and Controlling Phase of an Adaptive SDPM Strategy for the  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c28_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Monitoring and Controlling Phase of an Iterative SDPM Strategy for the  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c28_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Question")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c29_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 29 - The Adaptive SDPM Closing Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c29_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Closing Phase of the Adaptive SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c29_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iterative SDPM Strategy for the Closing Phase of the Adaptive Project Framework Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c29_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adaptive SDPM Strategy for the Closing Phase of the Adaptive Software  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c29_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Question")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c30_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 30 - The Adaptive SDPM Strategy Summary")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c30_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Adaptive Projects")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c30_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Adaptive Project Managers")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c30_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Adaptive Teams")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c30_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Adaptive Project Planning")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c30_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Adaptive Scope Change Management")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c30_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Question")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_p06_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART SIX - Extreme ESPM")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c31_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 31 - Extreme SDPM Strategy")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c31_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Extreme SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c31_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Types of Extreme SDPM Strategies")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c31_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c32_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 32 - The Extreme SDPM Scoping Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c32_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scoping Phase of an Extreme SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c32_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scoping Phase of the Extreme SDPM Strategy for the INSPIRE Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c32_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scoping Phase of the Extreme SDPM Strategy for the Flexible Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c32_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Question")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c33_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 33 - The Extreme SDPM Planning Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c33_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planning Phase of an Extreme SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c33_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planning Phase of an Extreme SDPM Strategy for the INSPIRE Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c33_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planning Phase of an Extreme SDPM Strategy for the Flexible Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c33_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c34_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 34 - The Extreme SDPM Launching Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c34_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching Phase of an Extreme SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c34_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching Phase of an Extreme SDPM Strategy for the INSPIRE Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c34_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Launching Phase of an Extreme SDPM Strategy for the Flexible Project Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c34_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Question")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c35_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 35 - The Extreme SDPM Monitoring and Controlling Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c35_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Monitoring and Controlling Phase of an Extreme SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c35_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Monitoring and Control Phase of an Extreme SDPM Strategy for the INSPIRE Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c35_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Monitoring and Controlling Phase of an Extreme SDPM Strategy for the  ...")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c35_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Question")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c36_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 36 - The Extreme SDPM Closing Phase")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c36_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Closing Phase of the Extreme SDPM Strategy")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c36_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Iterative SDPM Strategy for the Closing Phase of the INSPIRE Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c36_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Extreme SDPM Strategy for the Closing Phase of the Flexible Model")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c36_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Question")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c37_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 37 - The Extreme SDPM Strategy Summary")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c37_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Extreme Projects")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c37_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Extreme Project Managers")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c37_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Extreme Teams")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c37_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Extreme Project Planning")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c37_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traditional Versus Extreme Scope Change Management")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c37_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Question")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cpt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_p07_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART SEVEN - In Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c38_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 38 - Where Are You?")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c38_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Perspective of the Enterprise")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c38_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From the Perspective of the Customer")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c38_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From the Perspective of the Project Manager")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c38_r1#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From the Perspective of the Development Team")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c38_r1#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tracking Where You Are")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c38_r1#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Question")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c39_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 39 - Where Do You Want To Go and How Can You Get There?")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c39_r1#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where Do You Want To Go?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c39_r1#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Will You Get There?")])]), _vm._v(" "), _c('div', {
    staticClass: "ch1"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_c39_r1#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discussion Questions")])]), _vm._v(" "), _c('div', [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_ap1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX A - What’s on the Web Site?")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_ap2_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX B - Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_ap3_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX C - The Project Overview Statement")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_ap4_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX D - Requirements Gathering")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_ap5_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX E - The Work Breakdown Structure")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_ap6_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX F - Estimation")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_ap7_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX G - The Project Network Diagram")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_ap8_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX H - The Resource Schedule")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_ap9_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX I - Organizing the Project Team")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_ap10_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER J - Project Performance Reporting")])]), _vm._v(" "), _c('div', {
    staticClass: "apt"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_ap11_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX K - Business Process Flow Diagramming")])]), _vm._v(" "), _c('div', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/wyso_9780470446539_oeb_in1_r1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b67d1a6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wyso_9780470446539_oeb_toc_r1.vue
// module id = 57
// module chunks = 0